import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const AircraftIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "AircraftGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M11.7247 20.6655H9.30282C9.15634 20.6655 9.01766 20.6016 8.92245 20.4902C8.82772 20.3789 8.78622 20.2314 8.80917 20.0874L9.73202 14.272H6.47079L5.30966 15.9268C5.2164 16.0601 5.06357 16.1397 4.90048 16.1397H2.9498C2.79306 16.1397 2.6456 16.0659 2.55087 15.9409C2.45614 15.8159 2.42587 15.6538 2.46884 15.5029L3.47665 11.9526L2.46981 8.50049C2.42586 8.34912 2.45516 8.18604 2.54989 8.06055C2.64413 7.93457 2.79257 7.86035 2.94979 7.86035H4.90047C5.0616 7.86035 5.21297 7.93799 5.30672 8.06885L6.49617 9.72803H9.7574L8.80916 3.91504C8.78572 3.77002 8.82674 3.62256 8.92195 3.51074C9.01668 3.39892 9.15633 3.33447 9.30281 3.33447H11.7247C11.9327 3.33447 12.1192 3.46338 12.1925 3.6582L14.482 9.72802H19.3346C19.7652 9.72802 20.1915 9.83886 20.5675 10.0478L21.6705 10.6616C22.1554 10.9321 22.4469 11.4248 22.4503 11.9795C22.4532 12.5342 22.1676 13.0303 21.6856 13.3057L20.5802 13.9375C20.1983 14.1562 19.7633 14.272 19.3219 14.272H14.4298L12.1939 20.3384C12.1212 20.5352 11.9342 20.6655 11.7247 20.6655ZM9.88827 19.6655H11.3761L13.6119 13.5991C13.6847 13.4023 13.8717 13.272 14.0811 13.272H19.3219C19.589 13.272 19.8526 13.2021 20.0836 13.0698L21.1895 12.4375C21.4264 12.3022 21.4508 12.0762 21.4503 11.9853C21.4498 11.894 21.4225 11.6685 21.1842 11.5356L20.0811 10.9219C19.8536 10.7949 19.5953 10.728 19.3346 10.728H14.1363C13.9283 10.728 13.7418 10.5991 13.6686 10.4043L11.379 4.33446H9.89072L10.839 10.1475C10.8624 10.2925 10.8214 10.4399 10.7262 10.5518C10.6314 10.6636 10.4918 10.728 10.3453 10.728H6.23935C6.07822 10.728 5.92685 10.6504 5.8331 10.5195L4.64365 8.86034H3.61631L4.47715 11.8105C4.50352 11.9009 4.50401 11.9966 4.47813 12.0874L3.61143 15.1397H4.64024L5.80137 13.4849C5.89463 13.3516 6.04746 13.272 6.21055 13.272H10.3175C10.464 13.272 10.6026 13.3359 10.6979 13.4473C10.7926 13.5586 10.8341 13.7061 10.8111 13.8501L9.88827 19.6655Z"
        fill="#696969"
      />
    </svg>
  );
};

export default AircraftIcon;
